import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      ref={headerRef}
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group cursor-pointer"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
              51吃瓜
            </span>
            <span className="hidden sm:inline text-xs font-label text-foreground-500 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
              官网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-label whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                isActive('/')
                  ? 'text-primary-500 font-semibold'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {categories.filter(c => c.featured).slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-label whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  isActive(`/category/${cat.slug}`)
                    ? 'text-primary-500 font-semibold'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-label whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                isActive('/about')
                  ? 'text-primary-500 font-semibold'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-800"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70 bg-background-50">
            <div className="flex flex-col gap-1 pt-2">
              <Link
                to="/"
                className={`px-4 py-3 text-sm font-label rounded-lg transition-colors cursor-pointer ${
                  isActive('/') ? 'bg-primary-50 text-primary-600 font-semibold' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              {categories.filter(c => c.featured).slice(0, 4).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-3 text-sm font-label rounded-lg transition-colors cursor-pointer ${
                    isActive(`/category/${cat.slug}`) ? 'bg-primary-50 text-primary-600 font-semibold' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-3 text-sm font-label rounded-lg transition-colors cursor-pointer ${
                  isActive('/about') ? 'bg-primary-50 text-primary-600 font-semibold' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}